module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Mr-Mercedes-S2.15523c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Mr-Mercedes-S2.jpg
// module id = XXdG
// module chunks = 0